import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useEffect, useRef } from 'react';

import { useScrollableDialogStore } from '@/store/ui/scrollable-dialog.store';

export interface CustomScrollableCellModalProps {}

const CustomScrollableDialog: React.FC<CustomScrollableCellModalProps> = () => {
  const open =
    useScrollableDialogStore(s => s.scrollableDialog.isOpen) || false;
  const title = useScrollableDialogStore(s => s.scrollableDialog.title);

  const onClose = useScrollableDialogStore(s => s.scrollableDialog.onClose);
  const onConfirm = useScrollableDialogStore(s => s.scrollableDialog.onConfirm);
  const cancelTextBtn =
    useScrollableDialogStore(s => s.scrollableDialog.cancelTextBtn) ?? 'Cerrar';
  const confirmTextBtn = useScrollableDialogStore(
    s => s.scrollableDialog.confirmTextBtn
  );
  const closeTableCellDialog = useScrollableDialogStore(
    s => s.closeScrollableDialog
  );

  const contentText = useScrollableDialogStore(
    s => s.scrollableDialog.contentText
  );
  const contentNode = useScrollableDialogStore(
    s => s.scrollableDialog.contentNode
  );

  const scrollableDialogKey = useScrollableDialogStore(
    s => s.scrollableDialogKey
  );

  const descriptionElementRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
      <Dialog
        key={scrollableDialogKey || 'someInitialKey'}
        open={open}
        onClose={onClose || closeTableCellDialog}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{ '& .MuiDialog-paper': { width: '100%', minWidth: '50%' } }}
      >
        {/* ========= Title ========= */}
        <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>

        {/* ========= Content ========= */}
        <DialogContent dividers={true}>
          {contentNode || (
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
              {contentText}
            </DialogContentText>
          )}
        </DialogContent>

        {/* ========= Actions ========= */}
        <DialogActions>
          <Button onClick={onClose || closeTableCellDialog}>
            {cancelTextBtn}
          </Button>

          {!!onConfirm && <Button onClick={onConfirm}>{confirmTextBtn}</Button>}
        </DialogActions>
      </Dialog>
  );
};

export default CustomScrollableDialog;
